export enum NewConversationType {
  NewCustomerConversation,
  CustomerConversation,
}
export default NewConversationType;
